import { useState } from "react";
import Header3 from "../../Header3";
import Footer3 from "../../Footer3";
import PageBanner from "../../PageBanner";
import bannerBg from '../../../assets/img/page-banner.jpg'
import AgentDashboardView from "./AgentDashboardView";
import { isTokenValid, getPayload } from "../../../helpers/jwt";
import { toast, ToastContainer } from "react-toastify"
import { useHistory } from "react-router-dom";


function AgentDashboard() {

    const history = useHistory();

    if(!isTokenValid("agent_auth_token")){
        console.log("invalid token")
        toast.error('Login to access your dashboard.', {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
        });
        setTimeout(() => {
            history.push('/agent-portal');
        }, 2500);
    }
    const [agentId,setAgentId] = useState(getPayload("agent_auth_token").id);
    return (
        <>
            
            <Header3 />
            <PageBanner bannerBg={bannerBg} heading="Agent Dashboard" currentPage="Dashboard" />
            <AgentDashboardView agentId={agentId} />
            <Footer3 />
        </>
    );
}

export default AgentDashboard;
